import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../app/api";

const initialState = {
  // The access token used to authenticate requests to the API
  accessToken: window.localStorage.getItem("token") || undefined,

  // The authenticated username
  uuid: window.localStorage.getItem("u") || undefined,

  // The authenticated username
  adminUuid: window.localStorage.getItem("a") || undefined,

};

export const selectAccessToken = (state) => state.auth.accessToken;
export const selectUuid = (state) => state.auth.uuid;
export const selectAdminUuid = (state) => state.auth.adminUuid;

// Save the access token to local storage
export function saveAccessToken(accessToken) {
  window.localStorage.setItem("token", accessToken);
}

// Save the access token and username to local storage
export function saveCredentials(accessToken, uuid)
{
  saveAccessToken(accessToken);
  window.localStorage.setItem("u", uuid);
}

// Remove the access token and username from local storage
function removeCredentials() {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("u");
  window.localStorage.removeItem("a");
}

export function saveAdminCredentials(accessToken, uuid)
{
  saveAccessToken(accessToken);
  window.localStorage.setItem("a", uuid);
}

export function removeAdminCredentials() {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("a");
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      // This private reducer is not exported. The logout function below is the
      // public interface to log out, which also removes credentials from local
      // storage.
      state.accessToken = undefined;
      state.uuid = undefined;
      state.adminUuid = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.login.matchFulfilled, (state, action) => {
      state.accessToken = action.payload.access_token;
      state.uuid = action.payload?.uuid;
    });
    builder.addMatcher(api.endpoints.adminLogin.matchFulfilled, (state, action) => {
      state.accessToken = action.payload.access_token;
      state.adminUuid = action.payload?.uuid;
    });
  },
});

// Log out of the application.
//
// Call this instead of dispatching the logout() action directly, since this
// function also removes the token from the browser local storage.
export function logout() {
  return function logoutThunk(dispatch) {
    removeCredentials();
    dispatch(authSlice.actions.logout());
  };
}

export default authSlice.reducer;
